import { TraitSale } from "types";
import axios from "axios";
import { apiUrl } from "config";
import { BigNumber } from "ethers";

export const fetchTraitSales = async (
  address?: string
): Promise<TraitSale[]> => {
  const res = await axios.get<TraitSale[]>(`/trait-sales`, {
    baseURL: apiUrl,
    headers: address
      ? {
          Wallet: address,
        }
      : undefined,
  });

  return res.data.map((sale) => ({
    ...sale,
    price: BigNumber.from(sale.price),
  }));
};
